import {
	SHARED_CONVERSATION_PREVIEW,
	SHARED_CONVERSATION_PREVIEW_PAGE,
} from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { ROVO_CONVERSATION_SHARING_EXP } from '@townsquare/stat-sig/experiments';

// The recipient-facing read-only view of a shared Rovo Chat conversation,
// served at /chat/share/:shareToken (mirrors the backend share API naming).
export const sharedConversationPreviewRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: SHARED_CONVERSATION_PREVIEW_PAGE,
	path: SHARED_CONVERSATION_PREVIEW,
	layout: 'home',
	nav4Layout: 'expanded',
	experimentGating: {
		experiments: [{ key: ROVO_CONVERSATION_SHARING_EXP, cohort: 'test' }],
		behavior: { type: 'enabled' },
	},
	query: ['as?'],
});
